import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type DemoStopState = 'pending' | 'approaching' | 'served'
export type DemoParentStatus = 'waiting' | 'enroute' | 'onboard'

export interface DemoStopStatus {
  id: string
  name: string
  state: DemoStopState
  children: number
}

/** Suivi par parent — chaque parent ne voit/est notifié que pour son arrêt. */
export interface DemoParentInfo {
  email: string
  stopId: string
  stopName: string
  childrenFirstNames: string[]
  state: DemoParentStatus
  etaMin: number | null
}

/** État complet de la démo, diffusé par le conducteur via WebSocket. */
export interface DemoState {
  vehicleId: string
  lat: number
  lng: number
  progressPct: number
  speedKmh: number
  onboard: number
  totalChildren: number
  parentEtaMin: number | null
  parentStatus: DemoParentStatus
  stops: DemoStopStatus[]
  parents: DemoParentInfo[]
  running: boolean
  finished: boolean
  updatedAt: number
}

interface DemoSliceState {
  state: DemoState | null
}

const initialState: DemoSliceState = { state: null }

const demoSlice = createSlice({
  name: 'demo',
  initialState,
  reducers: {
    setDemoState: (state, action: PayloadAction<DemoState>) => {
      state.state = action.payload
    },
    resetDemo: state => {
      state.state = null
    },
  },
})

export const { setDemoState, resetDemo } = demoSlice.actions
export default demoSlice.reducer
